/**
 * Centralized Validation Error Messages
 *
 * This file contains all validation error messages used across the application.
 * Benefits:
 * - Consistency across all forms
 * - Easy updates (change once, affects all forms)
 * - Easy to translate (for multi-language support in future)
 */

export const fieldLengths = {
  first_name: {
    min: 2,
    max: 100,
  },
  last_name: {
    min: 2,
    max: 100,
  },
  email: {
    max: 254,
  },
  address: {
    max: 200,
  },
  city: {
    max: 100,
  },
  state: {
    max: 100,
  },
  zipcode: {
    max: 10,
  },
  patient_id: {
    max: 150,
  },
  medical_recommendation: {
    max: 150,
  },
};

export const validationErrors = {
  // Helper function to generate required field messages
  getRequiredField: (field) => `Please enter ${field?.toLowerCase()}.`,

  getMaxLength: (field, max) => {
    const capitalizedField = field?.charAt(0)?.toUpperCase() + field?.slice(1);
    return `${capitalizedField} must be less than ${max} characters long.`;
  },

  getMinLength: (field, min) => {
    const capitalizedField = field?.charAt(0)?.toUpperCase() + field?.slice(1);
    return `${capitalizedField} must be at least ${min} characters long.`;
  },

  // Email Validation
  email: {
    invalid: "Please enter valid email!",
  },

  // Password Validation
  password: {
    minLength: "Password must be at least 8 characters long!",
    uppercase: "Password must contain at least one uppercase letter (A-Z)!",
    lowercase: "Password must contain at least one lowercase letter (a-z)!",
    number: "Password must contain at least one number (0-9)!",
    specialChar:
      "Password must contain at least one special character (e.g., !@#$%^&*)!",
    notMatch: "Passwords must match!",
    sameAsOld: "New password must be different from current password!",
  },

  deskNumber: {
    positiveInteger: "Desk number must be a positive integer!",
  },
};
